// extracted by mini-css-extract-plugin
module.exports = {"Wrapper":"QuoteContainer__Wrapper_2kvDR","Author":"QuoteContainer__Author_3gGDN","Photo":"QuoteContainer__Photo_2a4E9","Job":"QuoteContainer__Job_3pplA"};